import { render, staticRenderFns } from "./ParentToChildren.vue?vue&type=template&id=6b044363"
import script from "./ParentToChildren.vue?vue&type=script&lang=js"
export * from "./ParentToChildren.vue?vue&type=script&lang=js"
import style0 from "./ParentToChildren.vue?vue&type=style&index=0&id=6b044363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports